module.exports = __webpack_public_path__ + "img/5.8f6de35d.png";